import React from 'react';
import SEO from '../components/SEO';
import Header from './law/components/Header';
import UploadArea from './law/components/UploadArea';
import FeatureCards from './law/components/FeatureCards';
import HowItWorks from './law/components/HowItWorks';
import Disclaimers from './law/components/Disclaimers';
import Footer from './law/components/Footer';
import './Law.css';

const Law = () => {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: '계약서 AI 분석 - FLOWTO.ai',
    description: '스마트폰으로 계약서를 촬영하고 AI가 불공정 조항을 자동 분석',
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Web',
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'KRW'
    },
    provider: {
      '@type': 'Organization',
      name: 'FLOWTO.ai',
      url: 'https://flowto-ai.com'
    }
  };

  return (
    <div className="law-page min-h-screen bg-white">
      <SEO
        title="계약서 AI 분석"
        description="스마트폰으로 계약서를 촬영하고 AI가 불공정 조항을 자동 분석"
        url="/law"
        type="website"
        structuredData={structuredData}
      />
      <Header />
      <UploadArea />
      <FeatureCards />
      <HowItWorks />
      <Disclaimers />
      <Footer />
    </div>
  );
};

export default Law;
